import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ShieldCheck, Truck, Mail } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-[#27272A] bg-[#09090B]">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-4 lg:px-8">
      <div className="lg:col-span-2">
        <Logo />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#A1A1AA]">
          AsicMod builds premium PETG cooling shrouds and accessories for Bitmain
          Antminer rigs — engineered for quieter, cooler, faster mining.
        </p>
        <div className="mt-6 flex flex-wrap gap-4 text-xs text-[#A1A1AA]">
          <span className="flex items-center gap-2"><ShieldCheck size={15} className="text-primary" /> Secure Payment</span>
          <span className="flex items-center gap-2"><Truck size={15} className="text-primary" /> Fast Shipping</span>
        </div>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Shop</h4>
        <ul className="mt-4 space-y-3 text-sm text-[#A1A1AA]">
          <li><Link to="/shop" className="hover:text-primary" data-testid="footer-shop">All Products</Link></li>
          <li><Link to="/product/asic-fan-shroud" className="hover:text-primary" data-testid="footer-shroud">ASIC Fan Shroud</Link></li>
          <li><Link to="/about" className="hover:text-primary" data-testid="footer-about">About Us</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Support</h4>
        <ul className="mt-4 space-y-3 text-sm text-[#A1A1AA]">
          <li><Link to="/contact" className="hover:text-primary" data-testid="footer-contact">Contact</Link></li>
          <li className="flex items-center gap-2"><Mail size={14} /> support@asicmod.com</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#27272A] py-6 text-center text-xs text-[#52525B]">
      © {new Date().getFullYear()} AsicMod. All rights reserved.
    </div>
  </footer>
);

export default Footer;
